import {AbstractControl, ValidatorFn} from '@angular/forms';

import {CompanyNameValidatorKey} from './custom-validator-keys';

export function CompanyNameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[a-zA-Z0-9\s.\-']+$/.test(controlValue) ? {[CompanyNameValidatorKey]: true} : null;
    };
}
